import axios from 'axios';

// Simple axios instance pointing at the backend base URL used elsewhere
export const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

